import {reviewCardSelector} from "../_selectors/reviewCard.selector";
import {reviewStoreSelector} from "../_selectors/reviewStore.selector";
import {ReviewState, ReviewStore} from "../review.interface";
import {CardMarkupViewerState} from "../../markup/cardMarkupViewer/cardMarkupViewer.interface";
import {put, select} from 'redux-saga/effects';
import {reviewActions} from "../review.slice";
import {markupFormatter} from "../../common";
import {CardStore} from "../../cards/cards.interface";

export function* showAnswerSaga() {
    const reviewCard: CardStore = yield select(reviewCardSelector);
    const review: ReviewStore = yield select(reviewStoreSelector);
    
    // Handle differently for multicards
    if (review.isMultiCard && review.state === ReviewState.SubcardQuestion) {
        yield put(reviewActions.showSubcardAnswer());
        return;
    }

    const cardMarkup = markupFormatter.parse(reviewCard!.markup);

    if (review.state === ReviewState.OnlyQuestion && cardMarkup.hint.length > 0) {
        yield put(reviewActions.setState({
            reviewState: ReviewState.QuestionAndHint,
            markupViewerState: CardMarkupViewerState.QuestionAndHint,
        }));
    } else {
        yield put(reviewActions.setState({
            reviewState: ReviewState.Answer,
            markupViewerState: CardMarkupViewerState.Full,
        }));
    }
}

/**
 * Saga to handle showing the answer for a subcard in a multicard
 */
export function* showSubcardAnswerSaga() {
    const review: ReviewStore = yield select(reviewStoreSelector);
    
    if (!review.isMultiCard) {
        return;
    }
    
    yield put(reviewActions.setState({
        reviewState: ReviewState.SubcardAnswer,
        markupViewerState: CardMarkupViewerState.Full,
    }));
}

